export { Property1TwoCoins } from "./Property1TwoCoins";
